import React, { useState } from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { downloadOutline, close } from 'ionicons/icons';
import styles from './InstallBanner.module.css';
import { isIOS } from '../utils/pwa-environment';

const INSTALL_BANNER_KEY = 'pwa_install_banner_dismissed';

interface InstallBannerProps {
  show: boolean;
  onDismiss?: () => void;
}

export const InstallBanner: React.FC<InstallBannerProps> = ({ show, onDismiss }) => {
  const [dismissed, setDismissed] = useState(() =>
    typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(INSTALL_BANNER_KEY) === '1' : false
  );

  if (!show || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(INSTALL_BANNER_KEY, '1');
    setDismissed(true);
    onDismiss?.();
  };

  const hint = isIOS()
    ? 'Tocca Condividi e poi "Aggiungi a Home"'
    : 'Menu ⋮ → Installa app';

  return (
    <div className={styles.banner}>
      <IonIcon
        icon={downloadOutline}
        className={styles.icon}
      />
      <div className={styles.text}>
        <span className={styles.title}>Installa l&apos;app</span>
        <span className={styles.hint}> — {hint}</span>
      </div>
      <IonButton
        fill="clear"
        size="small"
        onClick={handleDismiss}
        className={styles.dismissButton}
      >
        <IonIcon icon={close} />
      </IonButton>
    </div>
  );
};
